import React from "react";
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import {NODE_LEVEL} from "../../domain/HierarchyConstants";

export const ContentHierarchyIcon = (props) => {
  let contentIcon = null;

  if (props.nodeType === NODE_LEVEL.ROOT) {
    contentIcon = <FolderSpecialIcon sx={{ color: props.color }} />;
  } else if (props.nodeType === NODE_LEVEL.BRANCH) {
    contentIcon = <FolderOpenIcon />;
  }

  return contentIcon;
};
